import React, { useState, useEffect } from "react";
import { format, parseISO, set } from "date-fns";
import { sortingFns } from "@tanstack/react-table";
import { compareItems } from "@tanstack/match-sorter-utils";
import CorporateMasterTable from "../../../components/corporateAction/corpMaster/CorporateMasterTable";
import { contractAddIcon, downloadIcon } from "../../../assetData/icons";
import { actionPerm } from "../../../components/authNavigation/AuthNavbar";
import { sortData } from "../../../utils/sortData";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { downloadLoader } from "../../../assetData/loaders";

const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0;

  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId]?.itemRank,
      rowB.columnFiltersMeta[columnId]?.itemRank,
    );
  }

  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

let a = {
  B: "Bonus",
  S: "Split",
  R: "Reduction",
  C: "Consolidation",
  A: "Merger",
  X: "Demerger",
  D: "Dividend",
  G: "Right",
};

const CorporateActionMasterTable = (props) => {
  const {
    tableData,
    buttonConfig,
    setIsAdd,
    setIsEdit,
    setSelectedItemId,
    renderKey,
    setRenderKey,
    isLoading,
    setIsImport,
    setIsDelete,
    setGlobalFilters,
    actionPermissions,
    setRowData,
    setRejectedId,
    setIsFilter,
    isFilter,
    isDownloadClicked,
    isApproveClicked
  } = props;

  const [isRemarkText, setIsRemark] = useState("hidden");
  const [id, setId] = useState("");
  const [setscript, setScriptName] = useState("");
  const [inputileId, setInputileId] = useState("");
  const [rowId, setRowId] = useState({});
  const [isDropDownVisible, setDropDownVisibility] = useState(false);

  const [tableFilter, setTableFilter] = useState(tableData);
  const [sortingType, setSortingType] = useState("desc");
  const [sortColumn, setSortColumn] = useState("bookclose_recorddate");

  useEffect(() => {
    setTableFilter(tableData);
  }, [tableData]);

  const handleSorting = (column, sortType, type) => {
    setSortColumn(column);

    const sortedData = sortData({
      data: tableData,
      column,
      type,
      sortType,
    });

    setTableFilter(sortedData);
    setSortingType(sortingType === "asc" ? "desc" : "asc");
  };

  const setRowIdAndHideShow = (info) => {
    setRowId(info);
    setDropDownVisibility((prevVisibility) => !prevVisibility);
  };

  const removeHover = () => {
    setIsRemark("hidden");
    setScriptName("");
    setId("");
    setInputileId("");
  };

  const secScript = (info) => {
    setIsRemark("block");
    setId(info.getValue());
    setInputileId(info.row.original.inputile_id);
  };

  const isinHoverEffect = (info) => {
    setIsRemark("block");
    setScriptName(info.getValue());
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "i",
        header: () => <div className="">S. NO.</div>,
        cell: (info) => (
          <div className="flex h-[26px] items-center justify-center">
            {info.row.index + 1}.
          </div>
        ),
      },

      {
        accessorKey: "inputile_id",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "inputile_id",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex items-center justify-between"
          >
            <div>ID</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "inputile_id" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "inputile_id" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <></>,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },
      {
        accessorKey: "script_name",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "script_name",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className="flex w-[200px] items-center justify-between"
          >
            <div>SCRIP NAME</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "script_name" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "script_name" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => <div className="w-[200px]"></div>,
      },

      {
        accessorKey: "corpaction_tag",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "corpaction_tag",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex w-[80px] items-center justify-between"
          >
            <div>Corporate action</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "corpaction_tag" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "corpaction_tag" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => (
          <div className="flex h-[26px] items-center justify-start px-[2px]">
            {a[info.getValue()]}
          </div>
        ),
      },
      {
        accessorKey: "bookclose_recorddate",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "bookclose_recorddate",
                sortingType === "asc" ? "desc" : "asc",
                "date",
              );
            }}
            className="flex w-[95px] items-center justify-between"
          >
            <div>BC/Record date</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "bookclose_recorddate" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "bookclose_recorddate" &&
                  sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => (
          <div className="flex h-[26px] w-[95px] items-center justify-start px-[2px]">
            {info.getValue() &&
              format(new Date(info.getValue()), "dd MMM yyyy")}
          </div>
        ),
      },

      {
        accessorKey: "nse_exdate",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "nse_exdate",
                sortingType === "asc" ? "desc" : "asc",
                "date",
              );
            }}
            className="flex w-[95px] items-center justify-between"
          >
            nse Ex DATE{" "}
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "nse_exdate" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "nse_exdate" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => (
          <div className="flex h-[26px] w-[95px] items-center justify-start px-[2px] ">
            {info.getValue() &&
              format(new Date(info.getValue()), "dd MMM yyyy")}
          </div>
        ),
      },

      {
        accessorKey: "bse_exdate",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "bse_exdate",
                sortingType === "asc" ? "desc" : "asc",
                "date",
              );
            }}
            className="flex w-[95px] items-center justify-between"
          >
            bse Ex DATE{" "}
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "bse_exdate" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "bse_exdate" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => (
          <div className="flex h-[26px] w-[95px] items-center justify-start px-[2px]">
            {info.getValue() &&
              format(new Date(info.getValue()), "dd MMM yyyy")}
          </div>
        ),
      },

      {
        accessorKey: "price",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "price",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex w-[93px] items-center justify-end text-right"
          >
            <div>
              dIVIDEND/ <div>RIGHTS PRICE</div>
            </div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "price" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "price" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => {
          const value = Number(info.getValue());
          return (
            <div className="flex h-[26px] items-center justify-end px-[2px]">
              {isNaN(value) ? "" : value.toFixed(2)}
            </div>
          );
        },
      },

      {
        accessorKey: "multiplier",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "multiplier",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className="flex items-center justify-end text-right"
          >
            multiPLIER
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "multiplier" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "multiplier" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => {
          const value = Number(info.getValue());
          return (
            <div className="flex h-[26px] items-center justify-end px-[2px]">
              {isNaN(value) ? "" : value.toFixed(2)}
            </div>
          );
        },
      },

      {
        accessorKey: "company_name",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "company_name",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex w-[200px] items-center justify-between"
          >
            <div>secondary SCRIP NAME</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "company_name" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "company_name" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => (
          <div className="flex h-[26px] w-[200px] items-center justify-start truncate whitespace-nowrap px-[2px]"></div>
        ),
      },

      {
        accessorKey: "face_value",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "face_value",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex items-center justify-end text-right"
          >
            <div>fACE VALUE</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "face_value" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "face_value" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        cell: (info) => {
          const value = Number(info.getValue());
          return (
            <div className="flex h-[26px] items-center justify-end px-[2px]">
              {isNaN(value) ? "" : value.toFixed(2)}
            </div>
          );
        },
      },

      {
        accessorKey: "caa_status",
        header: () => (
          <div className=" flex w-[100px] items-center justify-center">
            caa status
          </div>
        ),
        cell: (info) => (
          <div className="flex h-[26px] items-center justify-center">
            {info.row.original.caa_status === "P" &&
            info.row.original.addl_status === null
              ? "Pending"
              : info.row.original.caa_status === "P" &&
                info.row.original.addl_status === "O"
              ? "Overdue"
              : info.row.original.caa_status === "A" &&
                info.row.original.addl_status === null
              ? "Approved"
              : info.row.original.caa_status === "A" &&
                info.row.original.addl_status === "S"
              ? "Auto Approved"
              : info.row.original.caa_status === "A" &&
                info.row.original.addl_status === "F"
              ? "Approved"
              : ""}
          </div>
        ),
      },

      {
        accessorKey: "status",
        header: () => <div className=" ">status</div>,
        cell: (info) => (
          <div className="flex h-[26px] items-center justify-center">
            {info.getValue()}
          </div>
        ),
      },
    ],
    [sortColumn, sortingType, tableData, tableFilter],
  );

  const actionConfig = [
     {
      id: "1",
      name: "Auto Approval",
      image: isApproveClicked ?downloadLoader : contractAddIcon,
      actionHandler: () => buttonConfig.autoApprovalHandler(),
      disable: isApproveClicked ? false : actionPerm(actionPermissions)?.edit_perm,
    },
    {
      id: "2",
      name: "Add Corp. Action",
      image: contractAddIcon,
      actionHandler: () => (setIsAdd(true), setRenderKey((prev) => prev + 1)),
      disable: actionPerm(actionPermissions)?.add_perm,
    },
    {
      id: "3",
      name: "Import Data",
      image: contractAddIcon,
      actionHandler: () => setIsImport(true),
      disable: actionPerm(actionPermissions)?.import_perm,
    },

    {
      id: "4",
      name: "Download Data",
      image: isDownloadClicked ? downloadLoader : downloadIcon,
      actionHandler: isDownloadClicked
        ? () => {}
        : buttonConfig.downloadHandler,
      disable: actionPerm(actionPermissions)?.download_perm,
    },
    
  ];

  const action = actionPerm(actionPermissions);

  const handleDownloadButtonClick = () => {
    buttonConfig.downloadHandler();
  };

  return (
    <CorporateMasterTable
      rowId={rowId}
      isDropDownVisible={isDropDownVisible}
      isRemarkText={isRemarkText}
      isLoading={isLoading}
      columns={columns}
      tableData={tableFilter?.length > 0 ? tableFilter : tableData}
      buttonConfig={buttonConfig}
      setIsAdd={setIsAdd}
      setIsEdit={setIsEdit}
      setSelectedItemId={setSelectedItemId}
      renderKey={renderKey}
      actionConfig={actionConfig}
      filterField
      id={id}
      setscript={setscript}
      inputileId={inputileId}
      setIsDelete={setIsDelete}
      setGlobalFilters={setGlobalFilters}
      handleDownloadButtonClick={handleDownloadButtonClick}
      actions={action}
      setRowData={setRowData}
      setRejectedId={setRejectedId}
      isinHoverEffect={isinHoverEffect}
      setRowIdAndHideShow={setRowIdAndHideShow}
      setIsFilter={setIsFilter}
      isFilter={isFilter}
    />
  );
};

export default CorporateActionMasterTable;
